var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7289 15.2661L25.427 15.1951L25.4949 29.2707L10.7969 29.3417L10.7289 15.2661Z",
    fill: "#B0D0F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4406 19.889L10.7224 15.2707L25.4205 15.1904L25.4406 19.889Z",
    fill: "#6298D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7859 29.2336L25.4852 29.2834L25.4172 15.2078L35.7179 15.158L35.7859 29.2336Z",
    fill: "#08509A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54651 10.5908L25.61 10.5132L25.6327 15.2118L9.5692 15.2894L9.54651 10.5908Z",
    fill: "#B0D0F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8762 15.1514L25.6318 15.2057L25.6091 10.5071L36.8535 10.4528L36.8762 15.1514Z",
    fill: "#08509A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3351 3.06128L21.0857 3.02384L21.1216 10.4532L13.371 10.4906L13.3351 3.06128Z",
    fill: "#B0D0F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0835 5.49222L13.3329 3.04254L21.0634 3.02246L21.0835 5.49222Z",
    fill: "#6298D0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5332 10.4089L21.1118 10.4351L21.0759 3.00577L26.4973 2.97958L26.5332 10.4089Z",
    fill: "#08509A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7043 0.572998L21.1577 0.532168L21.1697 3.00193L12.7163 3.04276L12.7043 0.572998Z",
    fill: "#B0D0F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1119 2.97998L21.1885 3.00859L21.1766 0.538833L27.1 0.510223L27.1119 2.97998Z",
    fill: "#08509A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.7729H5.50174L8.91522 29.9889H40.5",
    stroke: "#08509A",
    strokeWidth: 1.07263
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18445 15.572H42.5682L39.8173 29.989M40.5 34.7879H9.27667C7.95143 34.7879 6.86715 33.7037 6.86715 32.3784C6.86715 31.0532 7.95143 29.9689 9.27667 29.9689H12.3689",
    stroke: "#08509A",
    strokeWidth: 1.07263
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3488 41.6549C13.491 41.6549 14.417 40.7289 14.417 39.5867C14.417 38.4445 13.491 37.5186 12.3488 37.5186C11.2066 37.5186 10.2806 38.4445 10.2806 39.5867C10.2806 40.7289 11.2066 41.6549 12.3488 41.6549Z",
    stroke: "#08509A",
    strokeWidth: 1.07263
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7491 41.6549C38.8913 41.6549 39.8173 40.7289 39.8173 39.5867C39.8173 38.4445 38.8913 37.5186 37.7491 37.5186C36.6069 37.5186 35.6809 38.4445 35.6809 39.5867C35.6809 40.7289 36.6069 41.6549 37.7491 41.6549Z",
    stroke: "#08509A",
    strokeWidth: 1.07263
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.f00dfe41f5fe3f2e39b091918b5834da.svg";
export { ForwardRef as ReactComponent };